import React from 'react'
import PropTypes from 'prop-types'
import { Collapse as AntCollapse } from 'antd'
import Icon from 'components/patterns/Icon'
import withStyle from './CollapsibleWidget.style.js'

const CollapsibleWidget = ({
  children,
  className,
  header,
  panelClassName,
  activeKey,
  handleOnChange,
  showArrow,
  forceRender,
}) => (
  <AntCollapse
    bordered={false}
    defaultActiveKey={['1']}
    expandIcon={({ isActive }) => (
      <Icon size="large" icon={isActive ? 'FaCaretUp' : 'FaCaretDown'} />
    )}
    className={className}
    ghost={true}
    onChange={handleOnChange}
  >
    <AntCollapse.Panel
      header={header}
      className={panelClassName}
      key={activeKey}
      showArrow={showArrow}
      forceRender={forceRender}
    >
      {children}
    </AntCollapse.Panel>
  </AntCollapse>
)

CollapsibleWidget.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  panelClassName: PropTypes.string,
  children: PropTypes.node,
  ghost: PropTypes.bool,
  showArrow: PropTypes.bool,
  activeKey: PropTypes.string,
  handleOnChange: PropTypes.func,
  onClose: PropTypes.func,
  forceRender: PropTypes.bool,
  // when activeKey is same as defaultActiveKey (for single panel equals "1"), collapsible widget for that panel remains open by default
}

CollapsibleWidget.defaultProps = {
  className: '',
  header: '',
  panelClassName: '',
  showArrow: true,
}

export default withStyle(CollapsibleWidget)
